/**
 * Mock store for integration testing purposes.  Implements reducers for the actions which can be dispatched in isolation (outside of the web app itself).
 */
import { configureStore } from "@reduxjs/toolkit";
import { storylineReducer } from "./storyline";
import { notificationsReducer } from "./notifications";

export type StubStoreState = {
    parameterValues?: Record<string, any>;
    canvasState?: Record<string, any>;
    frameData?: Record<string, any>;
}

export const initializeStubStore = (initialState: StubStoreState) => configureStore({
    reducer: {
        storyline: storylineReducer,
        notifications: notificationsReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
    preloadedState: {
        notifications: {
            notifications: [],
            outstandingRequestCount: 0,
        },
        storyline: {
            parameterValues: new Map(Object.entries(initialState.parameterValues ?? {})),
            canvasState: initialState.canvasState ?? {},
            currentParagraph: {
                data: initialState.frameData ?? {},
            },
            datasources: new Map<string, any>(),
        }
    },
});